export default __webpack_public_path__ + "static/media/Download_disabled.541a8b7c.svg";